import './app.scss';
import { useEagerConnect } from "hooks/useEagerConnect";
import { BrowserRouter as Router, Switch, Route, } from "react-router-dom";
import HomePage from 'pages/homePage/HomePage';
import BearPage from 'pages/bearPage/BearPage';
import SalmonPage from 'pages/salmonPage/SalmonPage';
import Whitepaper from 'components/whitepaper/Whitepaper';
import { Toaster } from 'react-hot-toast';

function App() {
  useEagerConnect();

  return (
    <Router>
      <Toaster
        position="top-center"
        toastOptions={{
          success: { duration: 3000 },
          error: { duration: 3000 },
        }}
      />
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route exact path="/bear" component={BearPage} />
        <Route exact path="/salmon" component={SalmonPage} />
        <Route exact path="/whitePaper" component={Whitepaper} />
      </Switch>
    </Router>
  );
}

export default App;
